import { render, staticRenderFns } from "./canteenUselist.vue?vue&type=template&id=0799ca3d&scoped=true"
import script from "./canteenUselist.vue?vue&type=script&lang=js"
export * from "./canteenUselist.vue?vue&type=script&lang=js"
import style0 from "./canteenUselist.vue?vue&type=style&index=0&id=0799ca3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799ca3d",
  null
  
)

export default component.exports